import React from 'react';

import {Banner} from '/component/base/Banner/Banner';
import {Text} from '/component/base/Text/Text';
import {handleMaintenanceBanner} from '/component/partial/MaintenanceBanner/MaintenanceBanner.util';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './MaintenanceBanner.style';

interface MaintenanceBannerProps {
  maintenance: any;
}

export const MaintenanceBanner: React.FC<MaintenanceBannerProps> = ({
  maintenance,
}) => {
  const {tt} = useTranslation('component.MaintenanceBanner');
  const {isWithinRange, description, title, localStartDate, localEndDate} =
    handleMaintenanceBanner(maintenance);

  const renderDescription = () => {
    if (description) {
      return (
        <Text variant="body">
          {tt('MaintenanceBannerDescription', description)}
        </Text>
      );
    } else {
      return tt('MaintenanceBannerDescription', () => (
        <Text variant="body">
          The OPTAVIA Coach App is scheduled to be under maintenance from{' '}
          {localStartDate} to {localEndDate}.
        </Text>
      ));
    }
  };

  return (
    isWithinRange && (
      <Banner style={{base: styles.base}} verticalBanner alertLevel="important">
        <Text variant="heading">{tt('MaintenanceBannerHeader', title)}</Text>
        {renderDescription()}
      </Banner>
    )
  );
};
